const pointerMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)')
const reducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

// The hero's drawing leans a little towards the mouse, by how far the mouse is from the hero's middle.
const TvgHero = {
  init() {
    document.querySelectorAll<HTMLElement>('[data-tvg-hero]').forEach((hero) => {
      let frame: number | undefined

      const follow = (x: number, y: number) => {
        hero.style.setProperty('--tvg-hero-x', x.toFixed(3))
        hero.style.setProperty('--tvg-hero-y', y.toFixed(3))
      }

      hero.addEventListener('pointermove', (event) => {
        if (event.pointerType !== 'mouse' || !pointerMediaQuery.matches || reducedMotionMediaQuery.matches || frame !== undefined) {
          return
        }

        frame = window.requestAnimationFrame(() => {
          const bounds = hero.getBoundingClientRect()

          frame = undefined
          follow(
            ((event.clientX - bounds.left) / bounds.width) * 2 - 1,
            ((event.clientY - bounds.top) / bounds.height) * 2 - 1,
          )
        })
      })

      hero.addEventListener('pointerleave', () => {
        if (frame !== undefined) {
          window.cancelAnimationFrame(frame)
          frame = undefined
        }

        follow(0, 0)
      })
    })
  },
}

export default TvgHero
